import DOMPurify from 'dompurify';

// Splash Page Stuff
export default function() {

  var isHomepage = $('body').hasClass('homepage'); // check if on homepage
  var splashcookie = Cookies.get('splashpage'); // check if user have the splashpage cookie
  var refSameSite = document.referrer.indexOf(SITEBASEURL) === 0; // check if user came to the homepage from an internal page
  var refRelatedSite = document.referrer.indexOf('https://www.washingtoncofair.com/') === 0; // check if user came to the homepage from the relating site
  if (isHomepage && (splashcookie === undefined) && !refSameSite && !refRelatedSite) {
    $.ajax({
      url: 'https://cdn.saffire.com/theme-files/WashCoFairgrounds/dist/static/splashpage-new-new.html'
    }).done(function(data) {
      $('body').prepend(DOMPurify.sanitize(data));
      $('#splash-page').focus();
    });
    $('body.homepage').css('overflow', 'hidden');
    $('body>form').css('visibility', 'hidden');
  }

  $(document).on('click', '.js-enter-expo', function() {
    var splashpage = $('#splash-page');
    splashpage.addClass('hide-splash');
    $('body.homepage').css('overflow', 'initial');
    $('body>form').css('visibility', 'visible');
    Cookies.set('splashpage', 'homepage splash page viewed');
    setTimeout(function () {
      splashpage.css('display', 'none');
    }, 300);
  });

}
// End Splash Page Stuff